import React from 'react'
import PropTypes from 'prop-types'
import { LocalizedText, Field, LabeledInput, LockIcon } from 'labguard-cdk'
import { UserIcon } from 'src/components/common/icons'
import FormModal from '../FormModal'

const ChangePasswordModal = ({ providePassword, provideUsername }) => (
  <FormModal title={<LocalizedText id="WEB_CHANGE_PASSWORD" />}>
    <Field
      component={LabeledInput}
      type="text"
      name="username"
      disabled={!provideUsername}
      topLabel={<LocalizedText id="WEB_USERNAME" />}
      icon={UserIcon}
    />
    {providePassword && (
      <Field
        type="password"
        name="password"
        component={LabeledInput}
        topLabel={<LocalizedText id="WEB_YOUR_OLD_PASSWORD" />}
        icon={LockIcon}
        autoComplete="new-password"
      />
    )}
    <Field
      type="password"
      name="newPassword"
      component={LabeledInput}
      topLabel={<LocalizedText id="WEB_YOUR_NEW_PASSWORD" />}
      icon={LockIcon}
      autoComplete="new-password"
    />
    <Field
      type="password"
      name="confirmNewPassword"
      component={LabeledInput}
      topLabel={<LocalizedText id="WEB_CONFIRM_NEW_PASSWORD" />}
      icon={LockIcon}
      autoComplete="new-password"
    />
  </FormModal>
)

ChangePasswordModal.propTypes = {
  providePassword: PropTypes.bool,
  provideUsername: PropTypes.bool,
}

export default ChangePasswordModal
